export default __webpack_public_path__ + "static/media/search-white.6c1201d7.svg";